import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'


class CreateBloc {

    createChannel = new Subject();
    detailChannel = new Subject();
    signatoryChannel = new Subject();
    parentChannel = new Subject();
    typeChannel = new Subject();
    repository = new CreateRepository()
  
    constructor() {
        this.createChannel.next({status: apiResponse.INITIAL})
    }

    fetchCreate = async (query) => {
        this.createChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchCreate(query).then((result) => {
            this.createChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.createChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchDetail = async (query) => {
        this.detailChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDetail(query).then((result) => {
            this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.detailChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchSignatory = async (query) => {
        this.signatoryChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchSignatoryOfficial(query).then((result) => {
            this.signatoryChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.signatoryChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchType = async (query) => {
        this.typeChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchType(query).then((result) => {
            this.typeChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.typeChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchParent = async (query) => {
        this.parentChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchParent(query).then((result) => {
            this.parentChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.parentChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    
}

export default CreateBloc